import { render, staticRenderFns } from "./Marked.vue?vue&type=template&id=65ca88e2"
import script from "./Marked.vue?vue&type=script&lang=js"
export * from "./Marked.vue?vue&type=script&lang=js"
import style0 from "./Marked.vue?vue&type=style&index=0&id=65ca88e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports